// extracted by mini-css-extract-plugin
export default {"container":"headerCard_container__gzbJo","buttonWrapper":"headerCard_buttonWrapper__Y2PK2","divider":"headerCard_divider__V56Lt"};